// extracted by mini-css-extract-plugin
export default {"overlay":"MenuDrawer_overlay__ufDNC","menu":"MenuDrawer_menu__A26Mw","show":"MenuDrawer_show__eH1HH","fadeIn":"MenuDrawer_fadeIn__sZnOz","content":"MenuDrawer_content__KznfS"};